import { IframeHandle } from '@/types/web';

type RipsParentMessage = {
    source: string;
    type: string;
    payload?: {
        handled: boolean;
    };
};

export const postMessageToRips = (iframe: IframeHandle | null, message: RipsParentMessage) => {
    iframe?.postObjectMessage(message);
};
